import * as React from 'react';
import * as autoBind from 'react-autobind';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import EntitlementStatusModel from '../../types/EntitlementStatusModel';
import UserModel from '../../types/UserModel';
import Strings from '../../globals/Strings';
import Constants from '../../globals/Constants';
import {ModalStates} from '../../globals/Constants';
import ModalEventHandlersModel from '../../types/ModalEventHandlers';
import UrlParser from '../../utils/UrlParser/UrlParser';
import {MyWindow} from '../../types/MyWindow';
import subscriptionStates from '../../types/SubscriptionStates';
import {nullModalEventHandlersFactory} from '../../types/ModalEventHandlers';
import EntitlementsValidator from '../../services/EntitlementsValidator/EntitlementsValidator';

declare const window: MyWindow;

export default class EntitlementStatus extends React.Component<EntitlementStatusProps, EntitlementStatusState> {
   readonly state: EntitlementStatusState = {buyNowModalWasOpenFromUrlQuery: false, isValidationInProgress: false};

   constructor(props: EntitlementStatusProps) {
      super(props);
      autoBind(this);
   }

   componentDidMount() {
      this.openBuyNowModalFromUrlQueryStringForNonPaidUsers(this.props.entitlements);
   }

   componentDidUpdate() {
      if (this.props.entitlements && !this.state.buyNowModalWasOpenFromUrlQuery) {
         this.openBuyNowModalFromUrlQueryStringForNonPaidUsers(this.props.entitlements);
      }
   }

   openBuyNowModalFromUrlQueryStringForNonPaidUsers(entitlements: EntitlementStatusModel) {
      const {setModalState} = this.props;
      const userSubscriptionState = EntitlementsValidator.getUsersSubscriptionState(entitlements);
      const openBuyNowModalFromUrl = UrlParser.getUrlQueryParam(window.location.search, Constants.openBuyNowModalQueryParamString) === 'true';

      if (userSubscriptionState === subscriptionStates.inactive && openBuyNowModalFromUrl) {
         setModalState(ModalStates.buyNow, nullModalEventHandlersFactory());
         this.setState({
            buyNowModalWasOpenFromUrlQuery: true
         });
      }
   }

   handleClickBuyNow() {
      window.location.assign(this.props.storeUrl);
   }

   getExpirationText() {
      const {daysLeft, entitlements} = this.props;
      const {expirationDate, level} = entitlements;
      const levelLowerCase = level && level.toLowerCase();
      const {isValidationInProgress} = this.state;
      const entitlementHasExpired = EntitlementsValidator.isExpired(expirationDate);

      const isTrial = levelLowerCase === Constants.entitlements.levels.trial.toLowerCase();
      const isSubscriptionActive = EntitlementsValidator.getUsersSubscriptionState(entitlements) === subscriptionStates.active;

      const buyControlButton = isValidationInProgress ? null : <ControlButton
         buttonType={TscButtonType.cta}
         label={Strings.labels.buyButtonText}
         testId="buy-now-button"
         onClick={this.handleClickBuyNow} />;

      if (expirationDate && isTrial && !isSubscriptionActive) {
         let expirationText = null;
         if (daysLeft > 1) {
            expirationText = Strings.labels.trialExpiresInDays.replace('{param0}', String(daysLeft));
         } else if (daysLeft === 1 && !entitlementHasExpired) {
            expirationText = Strings.labels.trialExpiresToday;
         } else if (daysLeft < 1 || entitlementHasExpired) {
            expirationText = Strings.labels.trialExpired;
         }

         return <div><span className="expiration-status-text">{expirationText}</span>{buyControlButton}</div>;
      } else if (!isSubscriptionActive) {
         return buyControlButton;
      }

      return null;
   }

   render() {
      const {entitlements} = this.props;
      const loaded = !!entitlements.status;

      return (
         <div className="entitlement-status button-group">
            {loaded && <div className="entitlement-status-info">{this.getExpirationText()}</div>}
         </div>
      );
   }
}

export interface EntitlementStatusProps {
   entitlements: EntitlementStatusModel;
   daysLeft: number;
   currentUser: UserModel;
   storeUrl: string;
   setModalState(modalState: ModalStates, modalEventHandlersModel: ModalEventHandlersModel): void;
}

export interface EntitlementStatusState {
   buyNowModalWasOpenFromUrlQuery: boolean;
   isValidationInProgress: boolean;
}
